// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailK":"K_wave2DetailK__2HPq6"};